// TokioAssistanceManager.tsx (Antigo TokioCoverageDetails.tsx)

import { Box, Paper, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import * as React from "react";
import { AssistanceItemData } from "../../../../../shared/services/api/fire/types";
import { AssistanceCard } from "../components/AssistanceCard";

interface TokioAssistanceManagerProps {
	isLoading: boolean;
	tipo: "residential" | "commercial";
	setTipo: (value: "residential" | "commercial") => void;
	visibleAssistances: AssistanceItemData[];
	setVisibleAssistances: (next: AssistanceItemData[]) => void;
}

export const TokioAssistanceManager: React.FC<TokioAssistanceManagerProps> = ({ isLoading, tipo, setTipo, visibleAssistances, setVisibleAssistances }) => {
	return (
		<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0} mt={2}>
			<Box px={2} pt={1} pb={0.5} display="flex" alignItems="center" gap={2} mb={2}>
				<Typography variant="h6" color="primary">
					Assistências
				</Typography>

				<ToggleButtonGroup
					size="small"
					exclusive
					value={tipo}
					onChange={(_, v) => v && setTipo(v)}
					aria-label="Filtro de categoria"
					disabled={isLoading}
				>
					<ToggleButton value="residential" aria-label="Residencial">
						Residencial
					</ToggleButton>
					<ToggleButton value="commercial" aria-label="Comercial">
						Comercial
					</ToggleButton>
				</ToggleButtonGroup>
			</Box>

			<Box px={2}>
				<AssistanceCard isLoading={isLoading} assistances={visibleAssistances} setAssistances={setVisibleAssistances} />
			</Box>
		</Box>
	);
};
